import { SearchRequest } from '@marageti/z4-sdk/lib/entity';
import { TripMatch, TripMatchStatus } from '@marageti/z4-sdk/lib/travel';

export const defaultTripMatchesSearchRequest = (page: number): SearchRequest => ({
  sortBy: [{
    field: 'createdAt',
    order: 'desc',
  }],
  filterBy: [{
    field: 'status',
    value: [
      TripMatchStatus.MatchPending,
      TripMatchStatus.MatchAccepted,
      TripMatchStatus.MatchSold,
    ],
  }],
  pagination: {
    limit: 30,
    page,
  },
});

export const isDeclinedOrCanceled = (status: TripMatchStatus) => {
  const declinedOrCanceledStatuses = [
    TripMatchStatus.MatchPartnerDeclined,
    TripMatchStatus.MatchPartnerCanceled,
    TripMatchStatus.MatchTravelerCanceled,
    TripMatchStatus.MatchZicassoCanceled,
    TripMatchStatus.MatchZicassoMatchError,
    TripMatchStatus.MatchSoldCanceled,
    TripMatchStatus.MatchRefundedCanceled,
  ];

  return declinedOrCanceledStatuses.includes(status);
};

export const shouldShowSalesCard = (tripMatch: TripMatch) => {
  const statuses = [
    TripMatchStatus.MatchSold,
    TripMatchStatus.MatchSoldCanceled,
    TripMatchStatus.MatchRefundedCanceled,
  ];
  return statuses.includes(tripMatch.status);
};
